import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default function Hydro(props) {
    return (
        <SvgIcon viewBox="0 0 56 56" {...props} >
            <circle cx="28" cy="28" r="28" fill="white"/>
            <path d="M45.1111 22.5556C45.1111 22.5556 40.4444 27.2222 36.5555 27.2222C32.6666 27.2222 32.6666 22.5556 28 22.5556C23.3333 22.5556 23.3333 27.2222 19.4444 27.2222C15.5555 27.2222 10.8889 22.5556 10.8889 22.5556" stroke="black" fill="white" stroke-width="2"/>
            <path d="M45.1111 31.1111C45.1111 31.1111 40.4444 35.7778 36.5555 35.7778C32.6666 35.7778 32.6666 31.1111 28 31.1111C23.3333 31.1111 23.3333 35.7778 19.4444 35.7778C15.5555 35.7778 10.8889 31.1111 10.8889 31.1111" stroke="black" fill="white" stroke-width="2"/>
        </SvgIcon>
    );
}